"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResearchCoordination = void 0;
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var ResearchCoordination = (function (_super) {
    __extends(ResearchCoordination, _super);
    function ResearchCoordination() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.RESEARCH_COORDINATION,
            tags: [Tags_1.Tags.WILDCARD],
            cost: 4,
            metadata: {
                cardNumber: 'P40',
                description: 'After being played, when you perform an action, the wild tag counts as any tag of your choice.',
            },
        }) || this;
    }
    ResearchCoordination.prototype.play = function () {
        return undefined;
    };
    return ResearchCoordination;
}(Card_1.Card));
exports.ResearchCoordination = ResearchCoordination;
//# sourceMappingURL=ResearchCoordination.js.map